module.exports = __webpack_public_path__ + "media/images/ww500-0f57450ea52a78c0e6ac0b39ec34ebc1.svg";